import { createContext, useContext } from "react";

/**
 * Permissão de EXCLUIR, vinda do /api/me. Começa em `false` para que a tela
 * nasça sem lixeira e só as mostre quando o servidor confirmar quem é admin —
 * o contrário faria os botões piscarem para todo mundo no carregamento.
 */
const Ctx = createContext(false);

export const PermissoesProvider = Ctx.Provider;

/** Só administradores podem excluir registros (regra do Portal). */
export const usePodeExcluir = () => useContext(Ctx);
